module.exports = __webpack_public_path__ + "img/plant3.a8a37bc2.jpg";